<template>
  <!-- postpone parsing until the components get added -->
  <div class="chi-demos-wrapper" v-pre>
    <div class="chi-demos-header" title="Click to pin the ribbon open" v-on:click="onclick" v-on:mousedown="onmousedown" v-on:mouseout="onunhover" v-on:mouseover="onhover" v-on:mouseup="onmouseup">
      <div data-safe-id="chi_chi_demos_summary" data-properties="{
        'classes': ['chi-demos-summary'],
        'style': {},
        'hint': '',
        'shared': true,
        'value': 'Select Patient'
      }" :class="components.chi_chi_demos_summary.classes" :style="components.chi_chi_demos_summary.style" :title="components.chi_chi_demos_summary.hint" :value="components.chi_chi_demos_summary.value" :id="'chi-demos-summary'" autocomplete="off" readonly ref="chi-demos-summary" role="readonlyfield" tabindex="-1" v-html="components.chi_chi_demos_summary.value"></div>
      <kendo-button data-safe-id="chi_chi_demos_search" data-properties="{
        'classes': ['chi-demos-summary-button'],
        'style': {},
        'content': '',
        'hint': 'Search patient accounts',
        'icon': 'find',
        'shared': true,
        'send': 'chi-demos-search'
        }" :class="components.chi_chi_demos_search.classes" :icon="components.chi_chi_demos_search.icon" :style="components.chi_chi_demos_search.style" :title="components.chi_chi_demos_search.hint" v-on:click="ondemobuttonclick" data-send="chi-demos-search" :id="'chi-demos-search'" ref="chi-demos-search" role="button">{{components.chi_chi_demos_search.content.replace(/ /g, '&amp;nbsp;')}}</kendo-button>
      <kendo-button data-safe-id="chi_chi_demos_recent" data-properties="{
        'classes': ['chi-demos-summary-button', 'recent'],
        'style': {},
        'content': '',
        'hint': 'Select from recently-viewed patient accounts',
        'icon': 'recent-patients',
        'shared': true,
        'send': 'chi-demos-recent'
        }" :class="components.chi_chi_demos_recent.classes" :icon="components.chi_chi_demos_recent.icon" :style="components.chi_chi_demos_recent.style" :title="components.chi_chi_demos_recent.hint" v-on:click="ondemobuttonclick" data-send="chi-demos-recent" :id="'chi-demos-recent'" ref="chi-demos-recent" role="button">{{components.chi_chi_demos_recent.content.replace(/ /g, '&amp;nbsp;')}}</kendo-button>
    </div>
    <div class="chi-demos-content" v-on:mousedown="onmousedown" v-on:mouseout="onunhover" v-on:mouseup="onmouseup">
      <div data-safe-id="chi_chi_demos_picture" data-properties="{
        'classes': ['chi-demos-picture'],
        'style': {},
        'file': 'RESOURCES/HTML/FMSGRAY.HTML',
        'hint': '',
        'shared': true,
        'template': ''
      }" :class="components.chi_chi_demos_picture.classes" :style="components.chi_chi_demos_picture.style" :title="components.chi_chi_demos_picture.hint" v-on:click="ondemolinkclick" :id="'chi-demos-picture'" ref="chi-demos-picture" role="htmlarea" v-html="components.chi_chi_demos_picture.template"></div>
      <div class="chi-form chi-demos-fields">
        <div class="chi-form-group" style="clear: left">
          <label for="chi-demos-pacct" :id="'label-10-15-110-36'">Account</label>
          <br />
          <input data-safe-id="chi_chi_demos_pacct" data-properties="{
            'classes': ['k-textbox'],
            'style': {
              'width': '8.1428rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_pacct.classes" :maxlength="components.chi_chi_demos_pacct.maxlength" :style="components.chi_chi_demos_pacct.style" :title="components.chi_chi_demos_pacct.hint" :value="components.chi_chi_demos_pacct.value" v-on:keyup.enter="$('#chi-demos-go').focus()" :id="'chi-demos-pacct'" autocomplete="off" ref="chi-demos-pacct" role="textfield" type="text" />
          <kendo-button data-safe-id="chi_chi_demos_go" data-properties="{
            'classes': ['small'],
            'style': {
              'border-color': '#f6f6f6'
            },
            'content': '',
            'hint': '',
            'icon': 'go',
            'send': 'chi-demos-go',
            'shared': true
          }" :class="components.chi_chi_demos_go.classes" :icon="components.chi_chi_demos_go.icon" :style="components.chi_chi_demos_go.style" :title="components.chi_chi_demos_go.hint" v-on:click="ondemobuttonclick" data-send="chi-demos-go" :id="'chi-demos-go'" ref="chi-demos-go" role="button">{{components.chi_chi_demos_go.content.replace(/ /g, '&amp;nbsp;')}}</kendo-button>
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-name" :id="'label-120-85-240-106'">Name</label>
          <br />
          <input data-safe-id="chi_chi_demos_name" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'color': 'rgb(76, 141, 224)',
              'cursor': 'pointer',
              'text-decoration': 'underline',
              'width': '18rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_name.classes" :style="components.chi_chi_demos_name.style" :title="components.chi_chi_demos_name.hint" :value="components.chi_chi_demos_name.value" v-on:click="on_menu_select" :id="'jump-Demographics-wme0615'" autocomplete="off" readonly ref="chi-demos-name" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-dob" :id="'label-120-85-240-106'">DOB</label>
          <br />
          <input data-safe-id="chi_chi_demos_dob" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '7.4285rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_dob.classes" :style="components.chi_chi_demos_dob.style" :title="components.chi_chi_demos_dob.hint" :value="components.chi_chi_demos_dob.value" :id="'chi-demos-dob'" autocomplete="off" readonly ref="chi-demos-dob" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-age" :id="'label-120-85-240-106'">Age</label>
          <br />
          <input data-safe-id="chi_chi_demos_age" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '10.571rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_age.classes" :style="components.chi_chi_demos_age.style" :title="components.chi_chi_demos_age.hint" :value="components.chi_chi_demos_age.value" :id="'chi-demos-age'" autocomplete="off" readonly ref="chi-demos-age" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-gender" :id="'label-120-85-240-106'">Gender</label>
          <br />
          <input data-safe-id="chi_chi_demos_gender" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '6.2142rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_gender.classes" :style="components.chi_chi_demos_gender.style" :title="components.chi_chi_demos_gender.hint" :value="components.chi_chi_demos_gender.value" :id="'chi-demos-gender'" autocomplete="off" readonly ref="chi-demos-gender" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-phys" :id="'label-120-85-240-106'">Primary Physician</label>
          <br />
          <input data-safe-id="chi_chi_demos_phys" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '17.071rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_phys.classes" :style="components.chi_chi_demos_phys.style" :title="components.chi_chi_demos_phys.hint" :value="components.chi_chi_demos_phys.value" :id="'chi-demos-phys'" autocomplete="off" readonly ref="chi-demos-phys" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group without-label" style="clear: left;">
          <kendo-button data-safe-id="chi_chi_demos_contacts" data-properties="{
            'classes': ['small'],
            'style': {
              'border-color': '#f6f6f6'
            },
            'content': '',
            'hint': '',
            'icon': 'address-book',
            'shared': true
          }" :class="components.chi_chi_demos_contacts.classes" :icon="components.chi_chi_demos_contacts.icon" :style="components.chi_chi_demos_contacts.style" :title="components.chi_chi_demos_contacts.hint" v-on:click="on_menu_select" :id="'jump-Demographics-wme0615-contacts'" ref="chi-demos-contacts" role="button">{{components.chi_chi_demos_contacts.content.replace(/ /g, '&amp;nbsp;')}}</kendo-button>
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-home" :id="'label-120-85-240-106'">(H) Phone</label>
          <br />
          <input data-safe-id="chi_chi_demos_home" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '8.0714rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_home.classes" :style="components.chi_chi_demos_home.style" :title="components.chi_chi_demos_home.hint" :value="components.chi_chi_demos_home.value" :id="'chi-demos-home'" autocomplete="off" readonly ref="chi-demos-home" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-work" :id="'label-120-85-240-106'">(W) Phone</label>
          <br />
          <input data-safe-id="chi_chi_demos_work" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '8.0714rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_work.classes" :style="components.chi_chi_demos_work.style" :title="components.chi_chi_demos_work.hint" :value="components.chi_chi_demos_work.value" :id="'chi-demos-work'" autocomplete="off" readonly ref="chi-demos-work" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group" style="">
          <label for="chi-demos-cell" :id="'label-120-85-240-106'">(M) Phone</label>
          <br />
          <input data-safe-id="chi_chi_demos_cell" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '8.0714rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_cell.classes" :style="components.chi_chi_demos_cell.style" :title="components.chi_chi_demos_cell.hint" :value="components.chi_chi_demos_cell.value" :id="'chi-demos-cell'" autocomplete="off" readonly ref="chi-demos-cell" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-address" :id="'label-120-85-240-106'">Address</label>
          <br />
          <input data-safe-id="chi_chi_demos_address" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'clear': 'left',
              'width': '30.5rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_address.classes" :style="components.chi_chi_demos_address.style" :title="components.chi_chi_demos_address.hint" :value="components.chi_chi_demos_address.value" :id="'chi-demos-address'" autocomplete="off" readonly ref="chi-demos-address" role="readonlyfield" type="text" />
        </div>
        <div class="chi-form-group">
          <label for="chi-demos-ins" :id="'label-120-85-240-106'">Primary Insurance</label>
          <br />
          <input data-safe-id="chi_chi_demos_ins" data-properties="{
            'classes': [
              'k-textbox'
            ],
            'style': {
              'width': '18.5rem'
            },
            'hint': '',
            'shared': true,
            'value': ''
          }" :class="components.chi_chi_demos_ins.classes" :style="components.chi_chi_demos_ins.style" :title="components.chi_chi_demos_ins.hint" :value="components.chi_chi_demos_ins.value" :id="'chi-demos-ins'" autocomplete="off" readonly ref="chi-demos-ins" role="readonlyfield" type="text" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../scss/_variables.scss";

.k-window-titlebar>.chi-demos-wrapper {
  display: block;
}
.chi-demos-wrapper {
  background: transparent;
  display: none;
  height: 2.2857rem;
  left: calc(50% - 0.5rem - 46.429rem);
  overflow: hidden;
  position: absolute;
  text-align: center;
  top: 0;
  width: 92.857rem;
  label {
    font-color: $light;
  }
  .chi-demos-header {
    background: $primary;
    color: $secondary;
    cursor: pointer;
    display: inline-block;
    height: 2.2857rem;
    padding: 0 0 0 2.5714rem;
    position: relative;
    width: auto;
    z-index: 10000;
    &::before {
      content: "\f105"; //$fa-var-angle-right;
      font-family: "Font Awesome 5 Pro";
      font-size: 120%;
      font-weight: 900;
      position: absolute;
      left: 0;
      text-align: center;
      top: 0.35714rem;
      width: 2.5714rem;
      .background & {
        visibility: hidden !important;
      }
    }
    .chi-demos-summary {
      float: left;
      padding: 0.5rem 0 0.5rem 0.57143rem;
      width: auto;
    }
    .chi-demos-summary-button {
      background-color: transparent;
      border: none;
      color: $secondary;
      width: 2.5714rem;
      &:focus, &:hover {
        box-shadow: none;
      }
      .background & {
        visibility: hidden !important;
      }
    }
  }
  &.hovered .chi-demos-header::before {
    content: "\f107"; //$fa-var-angle-down;
  }
  &.clicked .chi-demos-header::before {
    content: "\f08d"; //$fa-var-thumbtack;
  }
  .chi-demos-content {
    background: $primary;
    overflow: auto;
    position: relative;
    text-align: left;
    visibility: hidden;
    z-index: 1000;
    .chi-demos-picture {
      background-color: white;
      float: left;
      height: 7.7143rem;
      margin: 1.1428rem 0 1.1428rem 1.1428rem;
      overflow: hidden;
      position: relative;
      width: 7.7143rem;
      z-index: 1000;
      a {
        height: 100%;
        overflow: hidden;
        width: 100%;
        img {
          height: 100% !important;
          width: 100% !important;
        }
      }
    }
    #chi-demos-go {
      &:focus, &.k-state-focused,
      &:focus:hover, &:hover.k-state-focused,
      &:focus.k-state-hovered, &.k-state-hovered.k-state-focused {
        border-color: rgba($primary, 0.75);
        box-shadow: 0 0 0.21429rem 0.21429rem rgba($light, 0.5);
        color: $primary;
      }
    }
    .chi-form, .chi-form-group {
      position: relative;
      z-index: 1000;
    }
    .chi-form.chi-demos-fields {
      float: left;
      width: calc(100% - 8.8571rem);
      padding-right: 0;
      button, input, label {
        position: relative;
        z-index: 1000;
      }
      label {
        color: $light;
      }
    }
  }
}
.chi-demos-wrapper.clicked, .chi-demos-wrapper.hovered {
  height: auto;
  overflow: auto;
  .chi-demos-content {
    visibility: visible;
  }
}
</style>

<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-vue-buttons';
import Events from '../js/events.js';
import Form from '../js/form.js';

const CLASSES_SELECTOR = '.chi-demos-content, .chi-demos-header, .chi-demos-fields, .chi-demos-picture';
const BUTTONS_SELECTOR = '#chi-demos-search, #chi-demos-recent';


export default {
  name: 'demographics',
  components: {
    'kendo-button': Button
  },
  inject: ['components'],
  mounted: function () {
    console.debug('demographics-mounted:', this);
    var self = this;
    this.$nextTick(function () {
      var components = self.$root.$options.api.vm.components;
      if (components && components.chi_chi_demos_summary) {
        $(self.$el).remove();
        return console.debug('skipping demographics within tab');
      }
      var win = self.$root.windows.peek().kendo;
      var element = $(self.$el);
      var pacct;
      var container = element.closest('.k-window');
      var titlebar = container.find('.k-window-titlebar');
      Form.activate_content(element, {
        inject: ['components'],
        created: function () {
          this.$ = $;
        },
        methods: {
          onclick: function () {
            if (container.hasClass('background'))
              return;
            this.onmouseup();
            if (element.hasClass('clicked')) {
              element.data('chi-unclick', true);
              element.removeClass('clicked');
            } else {
              element.addClass('clicked');
              pacct = pacct || element.find('#chi-demos-pacct');
              pacct.focus();
              pacct.select();
            }
            element.removeClass('hovered');
          },
          onhover: function () {
            if (
              container.hasClass('background') || 
              !components.chi_chi_demos_summary.value ||
              components.chi_chi_demos_summary.value === 'Select Patient'
            )
              return;
            if (!element.data('chi-unclick'))
              element.addClass('hovered');
          },
          onmousedown: function () {
            if (container.hasClass('background'))
              return;
            win.setOptions({draggable: false, resizable: false});
            if ($(event.target).closest(BUTTONS_SELECTOR).length) {
              element.removeClass('hovered');
              element.data('chi-unclick', false)
            }
          },
          onmouseup: function () {
            if (container.hasClass('background'))
              return;
            win.setOptions({draggable: true, resizable: true});
          },
          ondemobuttonclick: function (event) {
            if (container.hasClass('background'))
              return;
            if ($(event.target).closest(BUTTONS_SELECTOR).length)
              event.stopPropagation();
            else
              element.addClass('clicked');
            element.removeClass('hovered');
            Events.on_button_click.call(this, event);
            this.onmouseup();
          },
          ondemolinkclick: function (event) {
            if (container.hasClass('background'))
              return;
            this.onmouseup();
            element.addClass('clicked');
            element.removeClass('hovered');
            return Events.on_link_click.call(this, event);
          },
          onunhover: function (event) {
            if (container.hasClass('background'))
              return;
            if (
              $(event.target).closest(CLASSES_SELECTOR).length && 
              !$(event.relatedTarget).closest(CLASSES_SELECTOR).length
            ) {
              element.removeClass('hovered');
              element.data('chi-unclick', false)
            }
          }
        },
        name: 'DemosContent',
        parent: self.$root.$options.api.vm
      }, true);
      setImmediate(function () {
        element = $('.chi-demos-wrapper').last();
        element.insertAfter(titlebar.find('.k-window-title'));
      });
    });
  }
};
</script>
